import { render, staticRenderFns } from "./SelectPlacement.vue?vue&type=template&id=2506ddab&lang=pug&"
import script from "./SelectPlacement.vue?vue&type=script&lang=js&"
export * from "./SelectPlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports